import { TaskTemplateServiceTemplateQuery } from "../../../graphql-types";
import { selectTaskTemplateServiceReadyToHire } from "./select-task-template-service-ready-to-hire";
import { useReadyToHireImageQuery } from "./use-ready-to-hire-image-query";
import { ReadyToHireProps } from "./TaskTemplateService/ReadyToHire";

export function useReadyToHireProps(
  data: TaskTemplateServiceTemplateQuery
): ReadyToHireProps {
  const { callToActionUrl, displayCta } =
    selectTaskTemplateServiceReadyToHire(data);

  const womanCookingWithDaughterFluid = useReadyToHireImageQuery();

  return {
    callToActionUrl,
    displayCta,
    womanCookingWithDaughterFluid,
  };
}
